/**
 * Created by Youhn on 2017/9/14.
 */
require('es6-promise').polyfill()
require('isomorphic-fetch')
import store from './../store/store'
import { getToken } from '@/util/jwtAuth'
import { apiUrl } from './../config/env'
let headers = {
  // 'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json'
}
let httpRequest = (url, postData, call) => {
  store.state.isLoading = true
  url += (url.indexOf('?') > -1 ? '&' : '?') + 'UserToken=' + getToken()
  // console.log(url)
  if (postData === null) {
    httpGet(url, call)
  } else {
    httpPost(url, postData, call)
  }
}
let httpGet = (url, call) => {
  fetch(url, {
    method: 'GET',
    body: null
  }).then((res) => {
    store.state.isLoading = false
    return res.json()
  }).then((data) => {
    store.state.isLoading = false
    call(data)
  })
}
let httpPost = (url, postData, call) => {
  fetch(url, {
    method: 'POST',
    headers: headers,
    body: postData === null ? postData : JSON.stringify(postData)
  }).then((res) => {
    store.state.isLoading = false
    return res.json()
  }).then((data) => {
    console.log(data)
    call(data)
  })
}
let login = (postData, call) => {
  httpRequest(apiUrl + '/Mall/WxLogin', postData, call)
}
let getCategories = (postData, call) => {
  httpRequest(apiUrl + '/Mall/GetCategories', null, call)
}
/**
 * 根据品类别码获取商品列表
 * @param pData
 * @param call
 */
let getCommodityList = (pData, call) => {
  let url = apiUrl + '/Mall/GetCommodityList?MARA_MTART=' + pData.MARA_MTART + '&FERTH=' + pData.FERTH + '&ZPM=' + pData.ZPM + '&pageNum=' + pData.pageNum + '&kind=' + pData.kind + '&pageSize=' + pData.pageSize
  httpRequest(url, null, call)
}
/**
 * 根据品类别获取商品列表
 * @param pData
 * @param call
 */
let getCommoditybyName = (pData, call) => {
  let url = apiUrl + '/Mall/getCommoditybyName?commodityName=' + pData.commodityName + '&kind=' + pData.kind + '&pageNum=' + pData.pageNum + '&pageSize=' + pData.pageSize
  httpRequest(url, null, call)
}
let getCommodityDetail = (pData, call) => {
  let url = apiUrl + '/Mall/GetCommodityDetail?commodityOid=' + pData.commodityOid + (pData.bannerOId ? '&bannerOid='+ pData.bannerOId : '')
  httpRequest(url, null, call)
}
// 根据款式oid获取款式详情2020/9/8
let GetCommodityDetailForMatch = (pData, call) => {
  let url = apiUrl + '/Mall/GetCommodityDetailForMatch?commodityOid=' + pData.commodityOid + (pData.bannerOId ? '&bannerOid='+ pData.bannerOId : '')
  httpRequest(url, null, call)
}
let getCommodityMaterial = (call) => {
  let url = apiUrl + '/Mall/GetCommodityMaterial'
  httpRequest(url, null, call)
}
let getGoldstone = (id, call) => {
  let url = apiUrl + '/Mall/GetGoldstone?commodityOid=' + id
  httpRequest(url, null, call)
}
let getStoneRange = (id, stone, call) => {
  let url = apiUrl + '/Mall/GetStoneRange?commodityOid=' + id + '&stoneCode=' + stone
  httpRequest(url, null, call)
}
/**
 * 查询批次信息
 * @param pData
 * @param call
 */
let putInQuireBatchList = (pData, call) => {
  // let pData = {
  //   SortType:'',//排序类型：0：价格升序；1：价格降序；2：主石重升序；3
  //   CommodityOid:'',//商品Oid
  //   ZJSBM:'',//金石编码
  //   PriceFrom:'',//价格
  //   PriceTo:'',
  //   ZZSZLFrom:'',//主石重
  //   ZZSZLTo:'',
  //   ZJDFrom:'',// 净度
  //   ZJDTo:'',
  //   ZZJQHFrom:'',//戒指圈号
  //   ZZJQHTo:'',
  //   ZXLCCFrom:'',//项链尺寸
  //   ZXLCCTo:'',
  //   pageNum:'',
  //   pageSize:''
  // }
  httpRequest(apiUrl + '/Mall/PutInQuireBatchList', pData, call)
}
let getShopingCartList = (call) => {
  httpRequest(apiUrl + '/Mall/GetShopingCartList', null, call)
}
// 获取购物车数据2020/8/28
let getShopingCartData = (call) => {
  httpRequest(apiUrl + '/Mall/GetShoppingCartData', null, call)
}
let getShoppingCartQty = (call) => {
  httpRequest(apiUrl + '/Mall/GetShoppingCartQty', null, call)
}
let putAddBatchCart = (pData, call) => {
  httpRequest(apiUrl + '/Mall/PutAddBatchCart', pData, call)
}
let putAddMadeInlaidCart = (pData, call) => {
  httpRequest(apiUrl + '/Mall/PutAddMadeInlaidCart', pData, call)
}
// 提交常规配货到购物车2020/9/9
let PutAddBatchMatchCart = (pData, call) => {
  httpRequest(apiUrl + '/Mall/PutAddBatchMatchCart', pData, call)
}
let getMadeInlaidAmount = (pData, call) => {
  httpRequest(apiUrl + '/Mall/PutMadeInlaidAmount', pData, call)
}
let getMadeGoldAmount = (pData, call) => {
  httpRequest(apiUrl + '/Mall/PutMadeGoldAmount', pData, call)
}
/*
 购物车--提交素金
 */
let putAddMadeGoldCart = (pData, call) => {
  httpRequest(apiUrl + '/Mall/PutAddMadeGoldCart', pData, call)
}
/*
 购物车--提交易耗品
 */
let putAddMadeLossCart = (pData, call) => {
  httpRequest(apiUrl + '/Mall/PutAddMadeLossCart', pData, call)
}
let putDeleteCart = (pData, call) => {
  httpRequest(apiUrl + '/Mall/PutDeleteCart', pData, call)
}
/**
 *获取款式批次信息
 * @param id
 * @param call
 */
let getShopingBatch = (id, call) => {
  httpRequest(apiUrl + '/Mall/GetShopingBatch?commodityOid=' + id, null, call)
}
// 获取常规配货详情（用于查看常规配货详情，修改数量、删除）2020/9/9
let GetShopingMatch = (id, call) => {
  httpRequest(apiUrl + '/Mall/GetShopingMatch?commodityOid=' + id, null, call)
}
/**
 * 获取款式委外信息
 * @param id
 * @param call
 */
let getShopingMade = (id, call) => {
  httpRequest(apiUrl + '/Mall/GetShopingMade?commodityOid=' + id, null, call)
}
let getShopingGold = (id, call) => {
  httpRequest(apiUrl + '/Mall/GetShopingGold?commodityOid=' + id, null, call)
}
let putOrders = (pData, call) => {
  httpRequest(apiUrl + '/Mall/PutOrders', pData, call)
}
// 现货订单提交
let PutBatchOrder = (pData, call) => {
  httpRequest(apiUrl + '/Mall/PutBatchOrder', pData, call)
}
let getOrder = (pData, call) => {
  httpRequest(apiUrl + '/Order/GetOrder?pageNum=' + pData.pageNum + '&pageSize=' + pData.pageSize + '&dateFrom=' + pData.dateFrom + '&dateTo=' + pData.dateTo + '&bigCode=' + pData.bigCode + '&orderType=' + pData.orderType, null, call)
}
let getOrderDetail = (id, call) => {
  httpRequest(apiUrl + '/Order/GetOrderDetail?oid=' + id, null, call)
}
// 获取购物车提交原因备注选项列表
let getOrderReasonList = (call) => {
  httpRequest(apiUrl + '/Mall/GetOrderReasonList', null, call)
}
let getStoneRangeByCom = (id, call) => {
  httpRequest(apiUrl + '/Mall/GetStoneRangeByCom?commodityOid=' + id, null, call)
}
let getGoldstoneByFactory = (id, call) => {
  httpRequest(apiUrl + '/Mall/GetGoldstoneByFactory?oid=' + id, null, call)
}
let SetPassWord = (pData, call) => {
  httpRequest(apiUrl + '/Mall/SetPassWord', pData, call)
}
let getStore = (pData, call) => {
  httpRequest(apiUrl + '/Mall/GetStore', pData, call)
}
let getAllCommoditySeries = (call) => {
  httpRequest(apiUrl + '/Mall/GetAllCommoditySeries', null, call)
}
let getHomeImage = (call) => {
  httpRequest(apiUrl + '/Mall/GetHomeImage', null, call)
}
// 首页轮播2020/9/12
let GetBanners = (call) => {
  httpRequest(apiUrl + '/Mall/GetBanners', null, call)
}
// 获取首页banner对应款式接口2020/9/24
let GetCommodityListByBanner = (pData, call) => {
  httpRequest(apiUrl + '/Mall/GetCommodityListByBanner?pageNum=' + pData.pageNum + '&pageSize=' + pData.pageSize + '&bannerOid=' + pData.bannerOid, null, call)
}
let getHomePageSeries = (call) => {
  httpRequest(apiUrl + '/Mall/GetHomePageSeries', null, call)
}
let getHomePageCommodity = (pData, call) => {
  httpRequest(apiUrl + '/Mall/GetHomePageCommodity?pageNum=' + pData.pageNum + '&pageSize=' + pData.pageSize, null, call)
}
let getCommodityListBySeries = (pData, call) => {
  httpRequest(apiUrl + '/Mall/GetCommodityListBySeries?pageNum=' + pData.pageNum + '&pageSize=' + pData.pageSize + '&FERTH=' + pData.FERTH + '&ZPM=' + pData.ZPM + '&kind=' + pData.kind, null, call)
}
// 根据系列名获取可用于常规配货的款式列表2020/9/8
let GetCommodityListForMatch = (pData, call) => {
  httpRequest(apiUrl + '/Mall/GetCommodityListForMatch?pageNum=' + pData.pageNum + '&pageSize=' + pData.pageSize + '&FERTH=' + pData.FERTH + '&ZPM=' + pData.ZPM + '&key=' + pData.key, null, call)
}
let getCommodityOffStock = (pData, call) => {
  httpRequest(apiUrl + '/Mall/GetCommodityOffStock?pageNum=' + pData.pageNum + '&pageSize=' + pData.pageSize + '&ZPM=' + pData.ZPM + '&kind=' + pData.kind, null, call)
}
let getCommoditybyBySeriesAndName = (pData, call) => {
  httpRequest(apiUrl + '/Mall/GetCommoditybyBySeriesAndName?pageNum=' + pData.pageNum + '&pageSize=' + pData.pageSize + '&FERTH=' + pData.FERTH + '&commodityName=' + pData.commodityName + '&kind=' + pData.kind, null, call)
}
let getCommodityOffStockbyName = (pData, call) => {
  httpRequest(apiUrl + '/Mall/GetCommodityOffStockbyName?pageNum=' + pData.pageNum + '&pageSize=' + pData.pageSize + '&commodityName=' + pData.commodityName + '&kind=' + pData.kind, null, call)
}

// 获取挑货单列表 2020/10/19
let GetPickList = (pData, call) => {
  httpRequest(apiUrl + '/Mall/GetPickList?pageNum=' + pData.pageNum + '&pageSize=' + pData.pageSize, null, call)
}
// 获取挑货单详情 2020/10/19
let GetPickItem = (id, call) => {
  httpRequest(apiUrl + '/Mall/GetPickItem?id=' + id, null, call)
}
// 获取挑货单编辑备注 2020/10/19
let PutPickRemark = (pData, call) => {
  httpRequest(apiUrl + '/Mall/PutPickRemark', pData, call)
}
//  验证盘号是否可以被当前用户绑定 2021/01/28
let GetDiskVerifyByStore = (number, call) => {
  httpRequest(apiUrl + '/Mall/GetDiskVerifyByStore?number=' + number, null, call)
}
// 绑定挑货盘 2021/01/28
let PutBindPickDisk = (pData, call) => {
  httpRequest(apiUrl + '/Mall/PutBindPickDisk', pData, call)
}
// 取筛选必需的品类、系列、风格对照信息 2022/4/4
/*
MARA_MTART=（大类编码，根据banner取得的值传递，可以为 null 或者 空字符）
styles 风格
categories 品类
series 系列
code 实际值（筛选接口转递code）  value 页面展示文本
*/
let GetKeyValuesForSearch = (pData, call) => {
  httpRequest(
    apiUrl + '/Mall/GetKeyValuesForSearch?MARA_MTART='+ pData.MARA_MTART, null, call)
}
// let GetKeyValuesForSearch = (pData, call) => {
//   httpRequest(
//     apiUrl + '/Mall/GetKeyValuesForSearch?'
//     + (pData.MARA_MTART ? '&MARA_MTART='+ pData.MARA_MTART : '')
//     + (pData.styles ? '&styles='+ pData.styles : '')
//     + (pData.categories ? '&categories='+ pData.categories : '')
//     + (pData.series ? '&series='+ pData.series : '')
//     + (pData.code ? '&code='+ pData.code : '')
//     , 
//     null, 
//     call
//   )
// }
// 根据查询取款式列表 2022/04/4
let GetCommdotyListByQuery = (pData, call) => {
  httpRequest(apiUrl + '/Mall/GetCommdotyListByQuery', pData, call)
}

export { login, getCategories, getCommodityList, getCommoditybyName, getCommodityDetail, putInQuireBatchList, getShopingCartList, getShopingBatch, getShopingMade, getCommodityMaterial, getShoppingCartQty,
  putAddBatchCart, putAddMadeGoldCart, putAddMadeLossCart, putDeleteCart, getShopingGold, getGoldstone, getStoneRange, putAddMadeInlaidCart, getMadeGoldAmount, getMadeInlaidAmount, getOrder, getOrderDetail,
  putOrders, getOrderReasonList, getStoneRangeByCom, getGoldstoneByFactory, SetPassWord, getStore, getAllCommoditySeries, getHomeImage, getHomePageSeries, getHomePageCommodity, getCommodityListBySeries, getCommodityOffStock,
  getCommoditybyBySeriesAndName, getCommodityOffStockbyName, getShopingCartData, PutBatchOrder, GetCommodityListForMatch, GetCommodityDetailForMatch, PutAddBatchMatchCart, GetShopingMatch, GetBanners, GetCommodityListByBanner,
   GetPickList ,GetPickItem, PutPickRemark, GetDiskVerifyByStore, PutBindPickDisk,GetKeyValuesForSearch,GetCommdotyListByQuery}



// WEBPACK FOOTER //
// ./src/service/index.js